import { useLocation } from 'react-router'
import { DataDomain } from 'reportViewer'

export const useDataDomain = (): DataDomain => {
    const { pathname } = useLocation()

    return pathname.split('/')[1] as DataDomain
}
